module.exports = __webpack_public_path__ + "4606e8fdff445971a361d741120fc707.svg";